import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { api, getListItems } from "../../services/api";
import { getImageUrl } from "../../utils/imageUrl";
import { useSiteContent, sectionField } from "../../hooks/useSiteContent";

function BlogOne() {
  const { content } = useSiteContent("home");
  const [posts, setPosts] = useState([]);

  const subtitle = sectionField(content, "blog", "subtitle", "From Our Blog");
  const title = sectionField(content, "blog", "title", "News & Articles From Travel With Ammar");
  const ctaText = sectionField(content, "blog", "cta_text", "See More Articles");
  const ctaUrl = sectionField(content, "blog", "cta_url", "/blog");
  const readMore = sectionField(content, "blog", "read_more", "Read More");

  useEffect(() => {
    let cancelled = false;
    api.getBlogPosts({ per_page: 6 })
      .then((res) => {
        if (cancelled) return;
        const items = getListItems(res).map((post) => ({
          id: post.id,
          title: post.title || "",
          image: getImageUrl(post.image || post.banner_image, "blog") || "/assets/img/blog/blog_1_1.jpg",
          date: post.published_at || post.created_at || "",
          detailsLink: `/blog/${post.id}`,
        }));
        setPosts(items);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!posts.length) {
    return null;
  }

  return (
    <section className="bg-smoke overflow-hidden space overflow-hidden" id="blog-sec">
      <div className="container shape-mockup-wrap">
        <div className="mb-30 text-center text-md-start">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-7">
              <div className="title-area mb-md-0">
                <span className="sub-title">{subtitle}</span>
                <h2 className="sec-title">{title}</h2>
              </div>
            </div>
            <div className="col-md-auto">
              <Link to={ctaUrl} className="th-btn style4 th-icon">
                {ctaText}
              </Link>
            </div>
          </div>
        </div>

        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          pagination={{ clickable: true }}
          breakpoints={{
            576: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
          }}
          className="swiper th-slider has-shadow"
        >
          {posts.map((post) => (
            <SwiperSlide key={post.id}>
              <div className="blog-card">
                <div className="blog-img global-img">
                  <img src={post.image} alt={post.title} />
                </div>
                <div className="blog-content">
                  <div className="blog-meta">
                    <span>{post.date ? String(post.date).slice(0, 10) : ""}</span>
                  </div>
                  <h3 className="box-title">
                    <Link to={post.detailsLink}>{post.title}</Link>
                  </h3>
                  <Link to={post.detailsLink} className="th-btn style4 th-icon">
                    {readMore}
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default BlogOne;
